module.exports = __webpack_public_path__ + "img/vg.07b169de.svg";